import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export const CartIcon = ({ ...props }: IconProps) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_8456_1149)'>
      <g clipPath='url(#clip1_8456_1149)'>
        <path
          d='M3.27051 1.25C4.6931 1.25009 5.93184 2.17295 6.36035 3.5H14.6221C15.9896 3.50021 17.0007 4.77331 16.6914 6.10547L15.7148 10.3154C15.5132 11.184 14.8716 11.8559 14.0596 12.123C14.7731 12.5633 15.25 13.35 15.25 14.25C15.25 15.6307 14.1307 16.75 12.75 16.75C11.3693 16.75 10.25 15.6307 10.25 14.25C10.25 13.4307 10.6459 12.706 11.2549 12.25H8.24512C8.85407 12.706 9.25 13.4307 9.25 14.25C9.25 15.6307 8.13071 16.75 6.75 16.75C5.36929 16.75 4.25 15.6307 4.25 14.25C4.25 13.2851 4.79719 12.449 5.59766 12.0322C4.87595 11.7102 4.32616 11.0556 4.16309 10.2402L3.06543 4.75H3C2.0335 4.75 1.25 3.9665 1.25 3C1.25 2.0335 2.0335 1.25 3 1.25H3.27051Z'
          fill='white'
          stroke='black'
          strokeWidth='2'
          strokeLinejoin='round'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_8456_1149'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
      <clipPath id='clip1_8456_1149'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
